import React, { useState, useEffect, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../components/common/CustomTable';
import { MyContactsActions } from '../_store/MyContacts.slice';
import Button from '../components/common/ui/Button';
import CustomModal from '../components/common/CustomModal ';
import { showAlert } from '../components/common/showAlert';
import { useNavigate } from 'react-router-dom';
import Loader from '../components/common/Loader';
import TranslateFile from '../Loc/TranslateFile';
import useKioskRestrictIntervalValidation from '../hooks/useKioskRestrictIntervalValidation';
import { getStoredValue } from "../../src/_helpers/storageHelper";

const MyContacts = () => {
    const { loginResponse } = useSelector(state => state.kioskLogin);
    const { LoadInmateMyContactsDisplayDetails, UpdateInmateConnectionDetails, InmateFreeCreditBalanceResultDetails, LoadInmateCactasTransactionHistoryDetails } = useSelector(state => state.MyContacts);
    const dispatch = useDispatch();
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const [isShowTransactionpage, setisShowTransactionpage] = React.useState(false);
    const [selectedrow, setselectedrow] = React.useState();
    const [showPopup, setShowPopup] = useState(false);
    const [modalContent, setmodalContent] = useState('');
    const [modalContentColor, setmodalContentColor] = useState('#4a9a93');
    const navigate = useNavigate();
    const [isUpdate, setisUpdate] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const currentLang = TranslateFile();
    const isPageReloading = useSelector((state) => state.auth?.isPageReload);
    const storedLoginDetails = getStoredValue("loginDetails");
    const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();
    const sortedTransactions = [...LoadInmateMyContactsDisplayDetails].sort((a, b) =>
        new Date(a.PublicUserID) - new Date(b.PublicUserID)
    );

    useEffect(() => {
        validateKioskRestrictInterval(storedLoginDetails)
    }, []);

    useEffect(() => {
        setselectedrow(null); setisShowTransactionpage(false)
        if (storedloginResponse?.FacilityCode) {
            pageonLoad();
        }
    }, [isPageReloading]);

    const handlesendMail = (selectedrow) => {
        dispatch(MyContactsActions.loadValidateSendMailToPublicUser({
            userId: selectedrow?.PublicUserID,
            PublicUserName: selectedrow?.PublicUserName,
            PublicUserEmail: selectedrow?.PublicUserEmail,
            InmatesFullName: storedloginResponse?.InmateFullName,
            FacilityID: selectedrow?.FacilityID
        }));
    }


    useEffect(() => {
        if (isUpdate && UpdateInmateConnectionDetails?.length !== 0) {
            switch (UpdateInmateConnectionDetails) {
                case 1:
                    if (selectedrow.ConnectionStatusID !== 2) {
                        handlesendMail(selectedrow);
                    }
                    setmodalContent(selectedrow.ConnectionStatusID === 2 ? currentLang?.AlertPopup?.Rejected_Successfully : currentLang?.AlertPopup?.Approved_Successfully); setmodalContentColor('#4a9a93');
                    break;
                case -1:
                    setmodalContent(currentLang?.AlertPopup?.Operation_Failed); setmodalContentColor('#c8605e');
                    break;
                case -2:
                    setmodalContent(currentLang?.AlertPopup?.Connection_Cancelled_PU); setmodalContentColor('#c8605e');
                    break;
                case -3:
                    setmodalContent(currentLang?.AlertPopup?.Not_Request_Accept_By_Inmate); setmodalContentColor('#c8605e');
                    break;
                case -4:
                    setmodalContent(currentLang?.AlertPopup?.Not_Request_Cancel_By_PU); setmodalContentColor('#c8605e');
                    break;
                case -5:
                    setmodalContent(currentLang?.AlertPopup?.Not_Request_Accept_By_PU); setmodalContentColor('#c8605e');
                    break;
                case -6:
                    setmodalContent(currentLang?.AlertPopup?.The_Inmate_Connection_Limit_Exceeded); setmodalContentColor('#c8605e');
                    break;
            }
            setShowPopup(true); setselectedrow('')

        }
    }, [UpdateInmateConnectionDetails]);

    const pageonLoad = () => {
        setLoading(true);
        dispatch(MyContactsActions.LoadInmateMyContactsDisplay({ inmatesId: storedloginResponse?.InmateID, userID: 0, connectionStatus: 0 })).then(x => {
            setLoading(false);
        });
        setLoading(true);
        dispatch(MyContactsActions.InmateFreeCreditBalanceResult(storedloginResponse)).then(x => {
            setLoading(false);
        });
    }

    const Transactioncolumns = [
        {
            name: currentLang?.TableHeaders?.Transaction_From, selector: (row) => row.TransactionFrom, sortable: true,
            sortFunction: (a, b) => a.TransactionFrom.toLowerCase().localeCompare(b.TransactionFrom.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders?.Transaction_Type, selector: (row) => row.TransactionType, sortable: true,
            sortFunction: (a, b) => a.TransactionType.toLowerCase().localeCompare(b.TransactionType.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders?.Debit_ID, selector: (row) => row.InmateCreditDebitID, sortable: true,
        },
        { name: currentLang?.TableHeaders?.Transaction_Date, selector: (row) => row.TransactionDate, sortable: true },
        { name: currentLang?.TableHeaders?.Amount, selector: (row) => row.DebitAmount?.toFixed(2), sortable: true },
    ];

    const columns = [
        {
            name: currentLang?.TableHeaders?.First_Name, selector: (row) => row.PublicFirstName, sortable: true,
            sortFunction: (a, b) => a.PublicFirstName.toLowerCase().localeCompare(b.PublicFirstName.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders?.Last_Name, selector: (row) => row.PublicLastName, sortable: true,
            sortFunction: (a, b) => a.PublicLastName.toLowerCase().localeCompare(b.PublicLastName.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders?.Relation, selector: (row) => row.RelationShip, sortable: true,
            sortFunction: (a, b) => a.RelationShip.toLowerCase().localeCompare(b.RelationShip.toLowerCase())
        },
        { name: currentLang?.TableHeaders?.Credit_Amount, selector: (row) => row.CreditBalance?.toFixed(2), sortable: true },
        {
            name: currentLang?.TableHeaders?.Status, selector: (row) => row.ConnectionStatus, sortable: true,
            cell: (row) => (
                <div className="d-flex " title={SendInviteStatus(row.ConnectionStatus)} onClick={() => { handleONCLick(row) }}>
                    {SendInviteStatus(row.ConnectionStatus, true)}
                </div>
            ),
        },
    ];

    const SendInviteStatus = (status, isclassName = false) => {
        status = status === "Request Accepted" ? "Accepted"
            : status === "Request Rejected" ? "Rejected"
                : status === "Request Blocked" ? "Blocked"
                    : status === "Request Canceled" ? "Canceled"
                        : status === "Pending Approval" ? "pending Approval"
                            : status;

        const statusClasses = {
            accepted: "StatusSent",
            rejected: 'StatusPatch-danger', "pending approval": 'StatusPending',
            blocked: 'StatusPatch-blocked', canceled: 'Statusqueued'
        };
        return isclassName ? <span className={statusClasses[status?.toLowerCase()]}>{status?.toUpperCase()}</span> : status?.toUpperCase();
    };

    const handleTransactionHistrory = () => {
        setLoading(true); setselectedrow('');
        dispatch(MyContactsActions.loadLoadInmateCactasTransactionHistory(storedloginResponse)).then(x => {
            setLoading(false);
        });
        setisShowTransactionpage(true)
    }
    const handlerowCLick = (item) => {
        setselectedrow(item);
        item?.ConnectionStatusID == 2 ? handleShowConfiramation(item) : UpdateConnection(item);
    }
    const handleShowConfiramation = (item) => {
        showAlert(
            navigate,
            currentLang?.AlertPopup?.Message,
            currentLang?.AlertPopup?.Reject_Confirm,
            "question",
            "700px",
            "Yes",
            null, // Default redirect URL
            null,  // Redux dispatch function, optional
            null, // Redux action to dispatch, optional (should be passed as a function)
            true,  // Flag to toggle between OK and Yes/No
            "No", // Optional cancel button text if useConfirmCancel is true
            () => UpdateConnection(item)
        );
    }
    const UpdateConnection = (selectedrow) => {
        if (selectedrow?.PUIConnectionID) {
            const requestData = {
                puiConnectionID: selectedrow?.PUIConnectionID,
                userID: selectedrow?.PublicUserID,
                inmatesId: selectedrow?.InmateID,
                facilityID: selectedrow?.FacilityID,
                requestChangeUser: "Inmate",
                toConnectionStatusID: selectedrow?.ConnectionStatusID == 2 ? 4 : 2,
                action: 0,
                isSALoginAsPU: 0,
                inmateResidentID: storedloginResponse?.InmatesResdId,
                relationShip: "",
                inmateInvitePublicUserID: 0
            };
            setLoading(true);
            dispatch(MyContactsActions.loadUpdateInmateConnection(requestData)).then(x => {
                setLoading(false);
            });
            setisUpdate(true);
        }
    }
    const handleONCLick = (item) => {
        if (item == selectedrow) {
            setselectedrow(null);
            return;
        }
        if (item?.ConnectionStatus == "Request Accepted" || item?.ConnectionStatus == "Request Rejected")
            setselectedrow(item);
        else {
            setselectedrow("");
        }
    }
    return (
        <div className="dashboard-container" >
            <div className="dashboard-content">
                <div className="d-flex justify-content-between mb-1 pt-1">
                    <div className="align-self-start">
                        <div className="icon-container">
                            <h3 className="find-inmate-head">{!isShowTransactionpage ? currentLang?.MyContacts?.My_Contacts : currentLang?.MyContacts?.Trn_Histroy}</h3>
                        </div>
                    </div>
                    <div className="align-self-end">
                        {(isShowTransactionpage) ? (
                            <Button
                                className='btn-danger'
                                label={currentLang?.Buttons?.Back}
                                type="button"
                                status="back"
                                onClick={() => setisShowTransactionpage(false)}
                            />
                        ) : (
                            <Button
                                variant="success"
                                className="me-2 btn-danger"
                                label={currentLang?.Buttons?.Trn_Histroy}
                                type="button"
                                status="success"
                                disabled={false}
                                onClick={() => handleTransactionHistrory()}
                            />
                        )}
                    </div>
                </div>
                <div className="divider mb-3"></div>
                {InmateFreeCreditBalanceResultDetails[0]?.FreeCreditActiveStatus === 1 && <label className="subtitle msg-cost">
                    {currentLang?.MyContacts?.Available_Credits}
                    <span className="cost-value ml-5">
                        $<span >{parseFloat(InmateFreeCreditBalanceResultDetails[0]?.InmateFreeCreditAmount || 0).toFixed(2)}</span>
                    </span>
                </label>}
                <div className="card-default">
                    {/* <ScrollContainer maxHeight={height - 250}> */}
                    {/* Conditionally show table or "No data found" message based on the page type and data */}
                    {isShowTransactionpage ? (
                        LoadInmateCactasTransactionHistoryDetails?.length > 0 ? (
                            <Table
                                isScrollContainer={true}
                                columns={Transactioncolumns}
                                data={LoadInmateCactasTransactionHistoryDetails}
                                pagination
                                handleONCLick={() => { }}
                            />
                        ) : (
                            <span className="col-no-data">{currentLang?.No_Data_Found}</span>
                        )
                    ) : (
                        sortedTransactions?.length > 0 ? (
                            <>
                                {selectedrow?.ConnectionStatusID ? <div className="d-flex justify-content-center p-1">
                                    <Button status={selectedrow?.ConnectionStatusID == 2 ? "primary" : "success"}
                                        label={selectedrow.ConnectionStatusID == 2 ? currentLang?.Buttons?.Reject_Request : currentLang?.Buttons?.Accept_Request}
                                        onClick={() => { handlerowCLick(selectedrow) }}
                                        type="button" /> </div>
                                    :
                                    <label className="instructNotes"><i class="fa fa-info-circle no-cursor"></i> {currentLang?.MyContacts?.MyContacts_TableDes}</label>
                                }
                                <Table
                                    isSelectrow={true}
                                    selectedrow={selectedrow}
                                    isScrollContainer={true}
                                    columns={columns}
                                    data={sortedTransactions}
                                    pagination
                                    handleONCLick={handleONCLick}
                                />
                            </>
                        ) : (
                            <span className="col-no-data">{currentLang?.No_Data_Found}</span>
                        )
                    )}
                    {/* </ScrollContainer> */}
                </div>
                {showPopup && (
                    <CustomModal
                        color={modalContentColor}
                        content={modalContent}
                        onOkClick={() => { pageonLoad(); setShowPopup(false) }}
                    />
                )}
                {loading && <Loader />}
            </div>

        </div>
    );
};

export default memo(MyContacts);
